export function _(selector, currentNode)
{
    if (currentNode) {
        return currentNode.querySelector(selector);
    } else {
        return document.querySelector(selector);
    }
}

export function _all(selector)
{
    return document.querySelectorAll(selector);
}
